module.exports = __webpack_public_path__ + "static/media/IMG_8208.a81abccc.png";